export const clinicInfo = {
  name: 'Crystal Dental Studio',
  address: 'вулиця Юрія Іллєнка, 18Б, Київ, 04119',
  phone: '+380683434034',
  email: 'info@crystaldental.ua',
  workingHours: {
    weekdays: '9:00 - 19:00',
    saturday: '9:00 - 19:00',
    sunday: 'Вихідний'
  }
};

export const services = [
  {
    id: 1,
    title: 'Терапія',
    description: 'Лікування зубів та відновлення їх функції',
    image: '/img/terapia.png',
    isGroup: true,
    subServices: [
      {
        id: 11,
        title: 'Лікування карієсу',
        description: 'Безболісне видалення карієсу та пломбування зубів',
        duration: '90 хв',
        price: 'від 3000 грн'
      },
      {
        id: 12,
        title: 'Лікування каналів',
        description: 'Ендодонтичне лікування кореневих каналів',
        duration: '120 хв',
        price: 'від 9000 грн'
      },
      {
        id: 13,
        title: 'Високоестетичні реставрації',
        description: 'Відновлення зубів з максимальною естетикою',
        duration: '90 хв',
        price: 'від 3500 грн'
      }
    ]
  },
  {
    id: 2,
    title: 'Ортодонтія',
    description: 'Виправлення прикусу та вирівнювання зубів',
    image: '/img/ortodontia.png',
    isGroup: true,
    subServices: [
      {
        id: 21,
        title: 'Консультація',
        description: 'Первинна консультація ортодонта',
        duration: '30 хв',
        price: '1400 грн'
      },
      {
        id: 22,
        title: 'Брекетні системи',
        description: 'Встановлення та лікування брекет-системами',
        duration: 'Курс лікування',
        price: 'від 20000 грн'
      },
      {
        id: 23,
        title: 'Елайнери',
        description: 'Прозорі капи для виправлення прикусу',
        duration: 'Курс лікування',
        price: 'від 37000 грн'
      },
      {
        id: 24,
        title: 'Дитяча ортодонтія',
        description: 'Ортодонтичне лікування для дітей',
        duration: 'Курс лікування',
        price: 'від 5000 грн'
      }
    ]
  },
  {
    id: 3,
    title: 'Ортопедія',
    description: 'Протезування та відновлення зубів',
    image: '/img/ortopedia.png',
    isGroup: true,
    subServices: [
      {
        id: 31,
        title: 'Фіксація коронок та вкладок',
        description: 'Встановлення коронок та керамічних вкладок',
        duration: '90 хв',
        price: 'від 8000 грн'
      },
      {
        id: 32,
        title: 'Протезування',
        description: 'Відновлення зубного ряду протезами',
        duration: '120 хв',
        price: 'від 5500 грн'
      },
      {
        id: 33,
        title: 'Вініри',
        description: 'Керамічні накладки для естетики зубів',
        duration: '90 хв',
        price: 'від 13500 грн'
      },
      {
        id: 34,
        title: 'Капи',
        description: 'Захисні, спортивні, розвантажувальні капи',
        duration: '60 хв',
        price: 'від 2700 грн'
      }
    ]
  },
  {
    id: 4,
    title: 'Хірургія',
    description: 'Хірургічні втручання в порожнині рота',
    image: '/img/hirurgia.png',
    isGroup: true,
    subServices: [
      {
        id: 41,
        title: 'Видалення зубів',
        description: 'Професійне видалення зубів різної складності',
        duration: '60 хв',
        price: 'від 1200 грн'
      },
      {
        id: 42,
        title: 'Імплантація',
        description: 'Встановлення зубних імплантів',
        duration: '120 хв',
        price: 'від 12000 грн'
      },
      {
        id: 43,
        title: "М'якотканинна пластика",
        description: 'Пластичні операції на яснах',
        duration: '90 хв',
        price: 'від 800 грн'
      },
      {
        id: 44,
        title: 'Кісткова пластика',
        description: 'Відновлення кісткової тканини',
        duration: '150 хв',
        price: 'від 6400 грн'
      }
    ]
  },
  {
    id: 5,
    title: 'Пародонтологія',
    description: 'Лікування захворювань ясен та пародонту',
    image: '/img/paradontologia.png',
    isGroup: true,
    subServices: [
      {
        id: 51,
        title: 'Діагностика',
        description: 'Комплексна діагностика стану пародонту',
        duration: '30 хв',
        price: '600 грн'
      },
      {
        id: 52,
        title: 'Чистка',
        description: 'Професійна гігієна порожнини рота',
        duration: '60 хв',
        price: 'від 2900 грн'
      },
      {
        id: 53,
        title: 'Кюретаж',
        description: 'Глибока чистка пародонтальних кишень',
        duration: '90 хв',
        price: 'від 2800 грн'
      }
    ]
  },
  {
    id: 6,
    title: 'Чекап',
    description: 'Комплексна діагностика стану зубів',
    image: '/img/chepakchik.png',
    isGroup: true,
    subServices: [
      {
        id: 61,
        title: 'Огляд + консультація',
        description: 'Повний огляд та консультація лікаря',
        duration: '45 хв',
        price: '600 грн'
      },
      {
        id: 62,
        title: 'Товари для догляду',
        description: 'Засоби для догляду за порожниною рота',
        duration: 'Консультація',
        price: 'в асортименті'
      }
    ]
  }
];

export const team = [
  {
    id: 1,
    name: 'Цвятков Артем Іванович',
    position: 'Головний лікар',
    experience: '15 років досвіду',
    image: '/img/artemij.png',
    specialization: 'Стоматолог-хірург-ортопед',
    education: [
      'Вищий державний навчальний заклад України "Українська медична стоматологічна академія" - диплом спеціаліста',
      'Одеський регіональний інститут державного управління Національної академії державного управління при Президентові України - диплом магістра (31.12.2019), спеціальність: Публічне управління та адміністрування',
      'Спеціалізація: хірургічна стоматологія та імплантологія',
      'Постійне підвищення кваліфікації в галузі стоматології'
    ],
    achievements: [
      'Понад 2000 успішних імплантацій',
      'Експерт у складних випадках протезування',
      'Регулярний учасник міжнародних конференцій',
      'Автор наукових публікацій з імплантології'
    ],
    services: [
      'Імплантація зубів',
      'Складне видалення зубів',
      'Протезування на імплантах',
      'Кісткова пластика',
      'Синус-ліфтинг',
      'Повна реконструкція зубного ряду'
    ],
    bio: 'Артем - провідний фахівець у галузі хірургічної стоматології та імплантології. Його підхід поєднує найсучасніші технології з індивідуальним підходом до кожного пацієнта. Спеціалізується на складних випадках імплантації та повній реконструкції зубного ряду.'
  },
  {
    id: 2,
    name: 'Романова Анна Юріївна',
    position: 'Щелепно-лицевий хірург',
    experience: '12 років досвіду',
    image: '/img/anna.png',
    specialization: 'Хірург імплантолог',
    education: [
      '2010-2015 — НМУ імені О.О. Богомольця, стоматологічний факультет',
      '2017-2019 — клінічна ординатура на кафедрі стоматології Інституту післядипломної освіти НМУ імені О. О. Богомольця і центру щелепно-лицевої хірургії Київської обласної клінічної лікарні',
      'Член міжнародних асоціацій: AO Foundation, European Association for Cranio Maxillo Facial Surgery (EACMFS)',
      'Постійне підвищення кваліфікації в галузі щелепно-лицевої хірургії',
      'Участь у професійних конференціях та семінарах'
    ],
    achievements: [
      'Понад 1500 успішних хірургічних втручань',
      'Спеціаліст з естетичної імплантації',
      'Експерт у роботі з м\'якими тканинами',
      'Викладач курсів підвищення кваліфікації'
    ],
    services: [
      'Імплантація зубів',
      'Естетична імплантація',
      'Видалення зубів мудрості',
      'Пластика ясен',
      'Лікування пародонтиту',
      'Аугментація кісткової тканини'
    ],
    bio: 'Анна - висококваліфікований хірург-імплантолог з особливою увагою до естетичних аспектів лікування. Її робота відзначається бездоганною точністю та турботою про комфорт пацієнтів. Спеціалізується на естетичній імплантації у фронтальній зоні.'
  },
  {
    id: 3,
    name: 'Зубков Максим Ігорович',
    position: 'Лікар-ортопед',
    experience: '18 років досвіду',
    image: '/img/maskim.jpg',
    specialization: 'Ортопедична стоматологія',
    education: [
      'Харківський національний медичний університет (ХНМУ)'
    ],
    achievements: [
      'Понад 18 років клінічної практики',
      'Постійне підвищення кваліфікації',
      'Комплексний підхід до протезування',
      'Робота з пацієнтами різного віку'
    ],
    services: [
      'Протезування зубів',
      'Консультації з ортопедії',
      'Діагностика та планування лікування',
      'Відновлення зубного ряду'
    ],
    bio: 'Зубков Максим Ігорович - лікар-ортопед з 18-річним досвідом роботи. Випускник Харківського національного медичного університету. Спеціалізується на ортопедичній стоматології та протезуванні. Працює з пацієнтами різного віку, приділяє увагу індивідуальному підходу та якісному відновленню зубного ряду. Регулярно підвищує свою кваліфікацію, слідкує за сучасними методиками в ортопедії.'
  },
  {
    id: 4,
    name: 'Крук Ілона Сергіївна',
    position: 'Лікар-терапевт',
    experience: '3 роки досвіду',
    image: '/img/ilona.jpg',
    specialization: 'Художні реставрації, чистки та відбілювання',
    education: [
      'ПВНЗ Київський медичний університет',
      'Спеціалізація: терапевтична стоматологія'
    ],
    achievements: [
      'Спеціаліст з художніх реставрацій',
      'Експерт у професійних чистках',
      'Майстер естетичного відбілювання',
      'Індивідуальний підхід до кожного пацієнта'
    ],
    services: [
      'Художня реставрація зубів',
      'Професійна чистка зубів',
      'Відбілювання зубів',
      'Лікування карієсу',
      'Естетичне пломбування',
      'Профілактика захворювань'
    ],
    bio: 'Крук Ілона Сергіївна - лікар-терапевт з 3-річним досвідом роботи. Спеціалізується на художніх реставраціях, професійних чистках та відбілюванні зубів. Випускниця ПВНЗ Київський медичний університет. Її робота відзначається увагою до деталей та прагненням створити ідеальну усмішку для кожного пацієнта.'
  },
  {
    id: 5,
    name: 'Гаврилова Юлія Олегівна',
    position: 'Лікар-пародонтолог',
    experience: '13 років досвіду',
    image: '/img/doctorcases/Yulia/yulia.jpg',
    specialization: 'Пародонтологія',
    education: [
      'Луганський державний медичний університет',
      'Харківський національний медичний університет'
    ],
    achievements: [
      'Понад 13 років клінічної практики',
      'Постійне підвищення кваліфікації',
      'Комплексний підхід до лікування',
      'Робота з пацієнтами різного віку'
    ],
    services: [
      'Консультації з пародонтології',
      'Діагностика стану ясен',
      'Професійна гігієна',
      'Профілактичні процедури'
    ],
    bio: 'Гаврилова Юлія Олегівна - лікар-пародонтолог з 13-річним досвідом роботи. Здобула освіту в Луганському державному медичному університеті та Харківському національному медичному університеті. Працює з пацієнтами різного віку, приділяє увагу індивідуальному підходу та комплексній діагностиці. Регулярно підвищує свою кваліфікацію, слідкує за сучасними тенденціями в стоматології.'
  },
  // {
  //   id: 6,
  //   name: 'Добровольський Дмитро Валерійович',
  //   position: 'Лікар-терапевт (ендодонтист)',
  //   experience: '8 років досвіду',
  //   image: '/img/doctorcases/dmytro/ava.jpg',
  //   specialization: 'Терапевтична стоматологія, ендодонтія',
  //   education: [
  //     'Національний медичний університет імені О. О. Богомольця'
  //   ],
  //   achievements: [
  //     'Понад 8 років клінічної практики',
  //     'Постійне підвищення кваліфікації',
  //     'Комплексний підхід до лікування',
  //     'Робота з пацієнтами різного віку'
  //   ],
  //   services: [
  //     'Терапевтичне лікування',
  //     'Ендодонтичне лікування',
  //     'Консультації',
  //     'Діагностика'
  //   ],
  //   bio: 'Добровольський Дмитро Валерійович - лікар-терапевт (ендодонтист) з 8-річним досвідом роботи. Випускник Національного медичного університету імені О. О. Богомольця. Спеціалізується на терапевтичній стоматології та ендодонтії. Працює з пацієнтами різного віку, приділяє увагу якісному лікуванню та індивідуальному підходу. Регулярно підвищує свою кваліфікацію, слідкує за сучасними методиками в стоматології.'
  // },
  {
    id: 7,
    name: 'Цвяткова Людмила Володимирівна',
    position: 'Лікар-ортодонт',
    experience: '10 років досвіду',
    image: '/img/doctorcases/lydmila/lydmila.png',
    specialization: 'Ортодонтія',
    education: [
      'Українська медична стоматологічна академія (УМСА), м. Полтава (2015)',
      'Національний університет охорони здоров\'я України імені П. Л. Шупика (інтернатура та спеціалізація)'
    ],
    achievements: [
      'Понад 10 років клінічної практики',
      'Постійне підвищення кваліфікації',
      'Комплексний підхід до ортодонтичного лікування',
      'Робота з пацієнтами різного віку'
    ],
    services: [
      'Ортодонтичне лікування',
      'Встановлення брекет-систем',
      'Лікування елайнерами',
      'Консультації з ортодонтії'
    ],
    bio: 'Цвяткова Людмила Володимирівна - лікар-ортодонт з 10-річним досвідом роботи. У 2015 році закінчила Українську медичну стоматологічну академію (УМСА) в Полтаві. Пройшла інтернатуру та спеціалізацію в Національному університеті охорони здоров\'я України імені П. Л. Шупика. Спеціалізується на ортодонтичному лікуванні, встановленні брекет-систем та роботі з елайнерами. Працює з пацієнтами різного віку, приділяє увагу індивідуальному підходу та якісному результату.'
  }
];

export const doctorCases = {
  1: [ // Артем
    {
      id: 1,
      title: 'Заміна тимчасових коронок на постійні',
      description: 'Професійна заміна тимчасових коронок на постійні з відновленням естетики та функціональності',
      price: '20000 грн',
      preview: '/img/doctorcases/Artem/zaminakronok/1 (2).jpg',
      images: [
        '/img/doctorcases/Artem/zaminakronok/1 (2).jpg',
        '/img/doctorcases/Artem/zaminakronok/3 (3).jpg',
        '/img/doctorcases/Artem/zaminakronok/4 (2).jpg',
        '/img/doctorcases/Artem/zaminakronok/5.jpg'
      ]
    },
    {
      id: 2,
      title: 'Видалення зуба з імплантом і формувачем',
      description: 'Професійне видалення зуба з одночасною імплантацією та встановленням формувача ясен',
      price: '15000 грн',
      preview: '/img/doctorcases/Artem/vadileniezuba/24.jpg',
      images: [
        '/img/doctorcases/Artem/vadileniezuba/24.jpg',
        '/img/doctorcases/Artem/vadileniezuba/20 (2).jpg',
        '/img/doctorcases/Artem/vadileniezuba/23.jpg'
      ]
    }
  ],
  2: [ // Анна
    {
      id: 1,
      title: 'Заміна тимчасових коронок на постійні',
      description: 'Спеціалізується на складній хірургії. Те, що комусь здається складним або недосяжним, для Анни Юріївни є буденною роботою',
      price: '50000 грн',
      preview: '/img/doctorcases/Anna/2 (2).jpg',
      images: [
        '/img/doctorcases/Anna/2 (2).jpg',
        '/img/doctorcases/Anna/3 (2).jpg'
      ]
    }
  ],
  4: [ // Ілона
    {
      id: 1,
      title: 'Видалення карієсу',
      description: 'Професійне лікування карієсу з відновленням природної форми зуба',
      price: 'від 3500 грн',
      preview: '/img/doctorcases/Ilon/Vidil Caries/IMG_3255.JPG',
      images: [
        '/img/doctorcases/Ilon/Vidil Caries/IMG_3255.JPG',
        '/img/doctorcases/Ilon/Vidil Caries/IMG_3256.JPG',
        '/img/doctorcases/Ilon/Vidil Caries/IMG_3257.JPG',
        '/img/doctorcases/Ilon/Vidil Caries/IMG_3258.JPG',
        '/img/doctorcases/Ilon/Vidil Caries/IMG_3259.JPG'
      ]
    },
    {
      id: 2,
      title: 'Реставрація зубів',
      description: 'Художня реставрація зубів з відновленням естетики та функціональності',
      price: 'від 4000 грн',
      preview: '/img/doctorcases/Ilon/restavracia/IMG_2932.JPG',
      images: [
        '/img/doctorcases/Ilon/restavracia/IMG_2932.JPG',
        '/img/doctorcases/Ilon/restavracia/IMG_2933.JPG',
        '/img/doctorcases/Ilon/restavracia/IMG_2934.JPG',
        '/img/doctorcases/Ilon/restavracia/IMG_2937.JPG',
        '/img/doctorcases/Ilon/restavracia/IMG_2939.JPG'
      ]
    },
    {
      id: 3,
      title: 'Відбілювання зубів',
      description: 'Професійне відбілювання для бездоганної білосніжної усмішки',
      price: 'від 8000 грн',
      preview: '/img/doctorcases/Ilon/vidbil/DSC_3852.jpg',
      images: [
        '/img/doctorcases/Ilon/vidbil/DSC_3852.jpg',
        '/img/doctorcases/Ilon/vidbil/DSC_3860.jpg',
        '/img/doctorcases/Ilon/vidbil/DSC_3876.jpg',
        '/img/doctorcases/Ilon/vidbil/DSC_3898.jpg'
      ]
    }
  ],
  3: [ // Максим
    {
      id: 1,
      title: 'Протезування зубів',
      description: 'Якісне відновлення зубного ряду',
      price: 'від 5000 грн',
      preview: '/img/doctorcases/Maksim/chistka1/13.jpg',
      images: [
        '/img/doctorcases/Maksim/chistka1/13.jpg',
        '/img/doctorcases/Maksim/chistka1/13.1.jpg',
        '/img/doctorcases/Maksim/chistka1/13.2.jpg',
        '/img/doctorcases/Maksim/chistka1/13.3.jpg',
        '/img/doctorcases/Maksim/chistka1/13.4.jpg'
      ]
    },
    {
      id: 2,
      title: 'Протезування зубів',
      description: 'Якісне відновлення зубного ряду',
      price: 'від 5000 грн',
      preview: '/img/doctorcases/Maksim/chistka2/12.5.jpg',
      images: [
        '/img/doctorcases/Maksim/chistka2/12.5.jpg',
        '/img/doctorcases/Maksim/chistka2/12.jpg',
        '/img/doctorcases/Maksim/chistka2/12.1.jpg',
        '/img/doctorcases/Maksim/chistka2/12.3.jpg',
        '/img/doctorcases/Maksim/chistka2/12.4.jpg'
      ]
    },
    {
      id: 5,
      title: 'Протезування зубів',
      description: 'Якісне відновлення зубного ряду',
      price: 'від 5000 грн',
      preview: '/img/doctorcases/Maksim/chistka5/9.4.jpg',
      images: [
        '/img/doctorcases/Maksim/chistka5/9.4.jpg',
        '/img/doctorcases/Maksim/chistka5/9 (2).jpg',
        '/img/doctorcases/Maksim/chistka5/9.1.jpg',
        '/img/doctorcases/Maksim/chistka5/9.3.jpg',
        '/img/doctorcases/Maksim/chistka5/9.6.jpg',
        '/img/doctorcases/Maksim/chistka5/9.7.jpg',
        '/img/doctorcases/Maksim/chistka5/9.8.jpg'
      ]
    },
    {
      id: 6,
      title: 'Протезування зубів',
      description: 'Якісне відновлення зубного ряду',
      price: 'від 5000 грн',
      preview: '/img/doctorcases/Maksim/chistka6/7.6.jpg',
      images: [
        '/img/doctorcases/Maksim/chistka6/7.6.jpg',
        '/img/doctorcases/Maksim/chistka6/7.7.jpg',
        '/img/doctorcases/Maksim/chistka6/8.1.jpg',
        '/img/doctorcases/Maksim/chistka6/8.2.jpg',
        '/img/doctorcases/Maksim/chistka6/8.4.jpg',
        '/img/doctorcases/Maksim/chistka6/8.5.jpg'
      ]
    }
  ],
  6: [ // Дмитро
    {
      id: 1,
      title: 'Терапевтичне лікування',
      description: 'Якісне лікування та відновлення зубів',
      price: 'від 3000 грн',
      preview: '/img/doctorcases/dmytro/chistka1/DSC_9196.JPG',
      images: [
        '/img/doctorcases/dmytro/chistka1/DSC_9196.JPG',
        '/img/doctorcases/dmytro/chistka1/DSC_9206.JPG',
        '/img/doctorcases/dmytro/chistka1/DSC_9210.JPG',
        '/img/doctorcases/dmytro/chistka1/DSC_9212.JPG',
        '/img/doctorcases/dmytro/chistka1/DSC_9217.JPG',
        '/img/doctorcases/dmytro/chistka1/DSC_9223.JPG'
      ]
    },
    {
      id: 2,
      title: 'Терапевтичне лікування',
      description: 'Якісне лікування та відновлення зубів',
      price: 'від 3000 грн',
      preview: '/img/doctorcases/dmytro/chistka2/DSC_9167.JPG',
      images: [
        '/img/doctorcases/dmytro/chistka2/DSC_9167.JPG',
        '/img/doctorcases/dmytro/chistka2/DSC_9169.JPG',
        '/img/doctorcases/dmytro/chistka2/DSC_9172.JPG',
        '/img/doctorcases/dmytro/chistka2/DSC_9180.JPG'
      ]
    },
    {
      id: 3,
      title: 'Терапевтичне лікування',
      description: 'Якісне лікування та відновлення зубів',
      price: 'від 3000 грн',
      preview: '/img/doctorcases/dmytro/chistka3/DSC_5217.JPG',
      images: [
        '/img/doctorcases/dmytro/chistka3/DSC_5217.JPG',
        '/img/doctorcases/dmytro/chistka3/DSC_5219.JPG',
        '/img/doctorcases/dmytro/chistka3/DSC_5223.JPG',
        '/img/doctorcases/dmytro/chistka3/DSC_5233.JPG',
        '/img/doctorcases/dmytro/chistka3/DSC_5234.JPG'
      ]
    },
    {
      id: 4,
      title: 'Терапевтичне лікування',
      description: 'Якісне лікування та відновлення зубів',
      price: 'від 3000 грн',
      preview: '/img/doctorcases/dmytro/chistka4/DSC_0163.JPG',
      images: [
        '/img/doctorcases/dmytro/chistka4/DSC_0163.JPG',
        '/img/doctorcases/dmytro/chistka4/DSC_9918.JPG',
        '/img/doctorcases/dmytro/chistka4/DSC_9938.JPG',
        '/img/doctorcases/dmytro/chistka4/DSC_9954.JPG'
      ]
    }
  ],
  7: [ // Людмила
    {
      id: 1,
      title: 'Незнімний апарат на розширення верхньої щелепи типу Марко Роса',
      description: 'Ортодонтичне лікування з використанням апарату Марко Роса',
      price: 'від 15000 грн',
      preview: '/img/doctorcases/lydmila/aparatMarcoRoso/IMG_6148.JPG',
      images: [
        '/img/doctorcases/lydmila/aparatMarcoRoso/IMG_6148.JPG',
        '/img/doctorcases/lydmila/aparatMarcoRoso/IMG_6149.JPG',
        '/img/doctorcases/lydmila/aparatMarcoRoso/IMG_6150.JPG'
      ]
    },
    {
      id: 2,
      title: 'Естетична брекет-система',
      description: 'Ортодонтичне лікування з використанням естетичних брекетів',
      price: 'від 25000 грн',
      preview: '/img/doctorcases/lydmila/estetichnabreketsistema/зображення_viber_2025-11-27_15-55-36-841.jpg',
      images: [
        '/img/doctorcases/lydmila/estetichnabreketsistema/зображення_viber_2025-11-27_15-55-36-841.jpg',
        '/img/doctorcases/lydmila/estetichnabreketsistema/зображення_viber_2025-11-27_16-53-19-270.jpg',
        '/img/doctorcases/lydmila/estetichnabreketsistema/зображення_viber_2025-11-27_16-53-19-484.jpg'
      ]
    },
    {
      id: 3,
      title: 'Керамічна брекет-система',
      description: 'Ортодонтичне лікування з використанням керамічних брекетів',
      price: 'від 30000 грн',
      preview: '/img/doctorcases/lydmila/keramichnabreketsistema/collage.jpg',
      images: [
        '/img/doctorcases/lydmila/keramichnabreketsistema/collage.jpg',
        '/img/doctorcases/lydmila/keramichnabreketsistema/collage (1).jpg',
        '/img/doctorcases/lydmila/keramichnabreketsistema/collage (2).jpg',
        '/img/doctorcases/lydmila/keramichnabreketsistema/collage (3).jpg',
        '/img/doctorcases/lydmila/keramichnabreketsistema/collage (4).jpg',
        '/img/doctorcases/lydmila/keramichnabreketsistema/collage (5).jpg',
        '/img/doctorcases/lydmila/keramichnabreketsistema/collage (6).jpg'
      ]
    },
    {
      id: 4,
      title: 'Лікування елайнерами',
      description: 'Ортодонтичне лікування з використанням прозорих елайнерів',
      price: 'від 37000 грн',
      preview: '/img/doctorcases/lydmila/likuvanieelainirimi/collage (7).jpg',
      images: [
        '/img/doctorcases/lydmila/likuvanieelainirimi/collage (7).jpg',
        '/img/doctorcases/lydmila/likuvanieelainirimi/collage (1) (2).jpg',
        '/img/doctorcases/lydmila/likuvanieelainirimi/collage (2) (2).jpg',
        '/img/doctorcases/lydmila/likuvanieelainirimi/collage (3) (2).jpg'
      ]
    }
  ],
  5: [ // Юлія
    {
      id: 1,
      title: 'Професійна чистка зубів',
      description: 'Комплексна професійна гігієна порожнини рота',
      price: 'від 2500 грн',
      preview: '/img/doctorcases/Yulia/chistka1/IMG_2284.JPG',
      images: [
        '/img/doctorcases/Yulia/chistka1/IMG_2284.JPG',
        '/img/doctorcases/Yulia/chistka1/IMG_2287.JPG',
        '/img/doctorcases/Yulia/chistka1/IMG_2289.JPG',
        '/img/doctorcases/Yulia/chistka1/IMG_2292.JPG',
        '/img/doctorcases/Yulia/chistka1/IMG_2293.JPG'
      ]
    },
    {
      id: 2,
      title: 'Професійна чистка зубів',
      description: 'Комплексна професійна гігієна порожнини рота',
      price: 'від 2500 грн',
      preview: '/img/doctorcases/Yulia/chistka2/IMG_2280.JPG',
      images: [
        '/img/doctorcases/Yulia/chistka2/IMG_2280.JPG',
        '/img/doctorcases/Yulia/chistka2/IMG_2281.JPG',
        '/img/doctorcases/Yulia/chistka2/IMG_2282.JPG',
        '/img/doctorcases/Yulia/chistka2/IMG_2283.JPG'
      ]
    },
    {
      id: 3,
      title: 'Професійна чистка зубів',
      description: 'Комплексна професійна гігієна порожнини рота',
      price: 'від 2500 грн',
      preview: '/img/doctorcases/Yulia/chistka3/IMG_2285.JPG',
      images: [
        '/img/doctorcases/Yulia/chistka3/IMG_2285.JPG',
        '/img/doctorcases/Yulia/chistka3/2-3.png',
        '/img/doctorcases/Yulia/chistka3/2-4 (2).png',
        '/img/doctorcases/Yulia/chistka3/2-4.png'
      ]
    }
  ]
};

export const gallery = [
  {
    id: 1,
    category: 'results',
    image: '/img/gal1.png',
    title: 'Результат лікування 1'
  },
  {
    id: 2,
    category: 'results',
    image: '/img/gal2.png',
    title: 'Результат лікування 2'
  },
  {
    id: 3,
    category: 'results',
    image: '/img/gal3.jpg',
    title: 'Результат лікування 3'
  },
  {
    id: 4,
    category: 'results',
    image: '/img/gal4.jpg',
    title: 'Результат лікування 4'
  },
  {
    id: 5,
    category: 'results',
    image: '/img/gal5.png',
    title: 'Результат лікування 5'
  },
  {
    id: 6,
    category: 'results',
    image: '/img/gal6.jpg',
    title: 'Результат лікування 6'
  },
  {
    id: 7,
    category: 'clinic',
    image: '/img/clinic/IMG_5021.jpg',
    title: 'Інтер\'єр клініки'
  },

  {
    id: 9,
    category: 'clinic',
    image: '/img/gallery/DSC05725.jpeg',
    title: 'Інтер\'єр клініки'
  },
  {
    id: 10,
    category: 'clinic',
    image: '/img/gallery/DSC05951.jpeg',
    title: 'Інтер\'єр клініки'
  },
  {
    id: 11,
    category: 'clinic',
    image: '/img/gallery/DSC06003.jpeg',
    title: 'Інтер\'єр клініки'
  },
  {
    id: 12,
    category: 'clinic',
    image: '/img/gallery/DSC06063.jpeg',
    title: 'Інтер\'єр клініки'
  },
  {
    id: 13,
    category: 'clinic',
    image: '/img/gallery/DSC06096.jpeg',
    title: 'Інтер\'єр клініки'
  },
  {
    id: 14,
    category: 'clinic',
    image: '/img/gallery/DSC06143.jpeg',
    title: 'Інтер\'єр клініки'
  },
  {
    id: 15,
    category: 'results',
    image: '/img/do-posle-gallery/collage (1).jpg',
    title: 'ДО/ПІСЛЯ'
  },
  {
    id: 16,
    category: 'results',
    image: '/img/do-posle-gallery/collage (1) (2).jpg',
    title: 'ДО/ПІСЛЯ'
  },
  {
    id: 17,
    category: 'results',
    image: '/img/do-posle-gallery/collage (2).jpg',
    title: 'ДО/ПІСЛЯ'
  },
  {
    id: 18,
    category: 'results',
    image: '/img/do-posle-gallery/collage (2) (2).jpg',
    title: 'ДО/ПІСЛЯ'
  },
  {
    id: 19,
    category: 'results',
    image: '/img/do-posle-gallery/collage (3).jpg',
    title: 'ДО/ПІСЛЯ'
  },
  {
    id: 20,
    category: 'results',
    image: '/img/do-posle-gallery/collage (3) (2).jpg',
    title: 'ДО/ПІСЛЯ'
  },
  {
    id: 21,
    category: 'results',
    image: '/img/do-posle-gallery/collage (4).jpg',
    title: 'ДО/ПІСЛЯ'
  },
  {
    id: 22,
    category: 'results',
    image: '/img/do-posle-gallery/collage (5).jpg',
    title: 'ДО/ПІСЛЯ'
  },
  {
    id: 23,
    category: 'results',
    image: '/img/do-posle-gallery/collage (6).jpg',
    title: 'ДО/ПІСЛЯ'
  }
];

export const reviews = [
  {
    id: 1,
    name: 'Антон Масла',
    rating: 5,
    text: 'Дуже професійне обслуговування! Я в захваті! Поки робили чистку та відбілювання, подивився улюблений серіал, особливо хочу відзначити дівчат на ресепшені, занурився в атмосферу домашнього затишку. Дуже раджу цю клініку!!!',
    date: '3 роки тому'
  },
  {
    id: 2,
    name: 'Людмила Хоменко',
    rating: 5,
    text: 'Дуже хороша клініка, а особливо її адміністратор Любов, завжди привітна, усміхнена, уважна до деталей!!! Дуже цінний співробітник. Всім рекомендую Crystal Dental Studio!',
    date: '3 роки тому'
  },
  {
    id: 3,
    name: 'Iryna Melnyk',
    rating: 5,
    text: 'Відмінний професіонал Регеда-Врублевська Єлизавета Юріївна. Дуже якісно та безболісно провела ендодонтичне лікування. Рекомендую',
    date: '2 роки тому'
  },
  {
    id: 4,
    name: 'Анна Гришко',
    rating: 5,
    text: 'Дуже гідна клініка та професійний підхід у всьому, від сервісу, чистоти та краси навколо, до професіоналізму лікарів та персоналу. Ми з донькою безумно раді, що Вас знайшли.',
    date: '3 роки тому'
  },
  {
    id: 5,
    name: 'Андрій Заніздра',
    rating: 5,
    text: 'Хороша клініка, завдяки Єлизаветі Юріївні, буду обслуговувати рот тільки тут. Все сподобалось',
    date: '2 роки тому'
  },
  {
    id: 6,
    name: 'Анастасія Савченко',
    rating: 5,
    text: 'Доктор Вижу Сергій, професіонал своєї справи! Залишилась задоволена) Буду рекомендувати друзям. 5+',
    date: '3 роки тому'
  },
  {
    id: 7,
    name: 'Dmytro Bigun',
    rating: 5,
    text: 'Лікуюсь тут не вперше. Дізнався про клініку з інстаграму, вирішив дізнатися про можливість встановити брекет-систему. Тепер постійно тут роблю проф чистку, лікування зубів і т.д. Завжди все зроблено якісно. Дуже все подобається',
    date: '3 роки тому'
  },
  {
    id: 8,
    name: 'Nataliia Beis',
    rating: 5,
    text: 'Дякую велике клініці за прекрасну посмішку та здорові зуби 🦷. Вже три роки я не знаю що таке болить зуб. Три роки тому мені зробили зуби, а вчора я була на чистці та відбілюванні. Дуже уважний та ввічливий персонал. Дякую велике 😊',
    date: '3 роки тому'
  },
  {
    id: 9,
    name: 'Інна Афоніна',
    rating: 5,
    text: 'Ось і підійшло до кінця моє лікування і серце переповнює вдячність. Два довгих роки лікування — операції, імпланти, пластика ясен, тимчасові зуби і, нарешті, постійні. Цей шлях був непростим, але Господь подарував мені зустріч з чудовими лікарями.',
    date: '1 місяць тому'
  },
  {
    id: 10,
    name: 'Yana Kuyun',
    rating: 5,
    text: 'Тільки найкращі рекомендації про клініку та лікарів! І сервіс, і персонал просто молодці! Прекрасна команда спеціалістів. Доктор Добровольський Дмитро Валерійович, велике вам дякую за гарні зуби. Зробив реставрацію восьми зубів.',
    date: '2 роки тому'
  },
  {
    id: 11,
    name: 'Uliana Rafalska',
    rating: 5,
    text: 'Постійний пацієнт стоматології Crystal Dental Studio. Висококваліфіковані спеціалісти проведуть лікування зубів будь-якої складності від чистки та відбілювання до складних видалень зубів мудрості з використанням сучасного обладнання. Дуже рекомендую!',
    date: 'Рік тому'
  },
  {
    id: 12,
    name: 'Марія Попова',
    rating: 5,
    text: 'У клініці сподобалось все! Починаючи з гарної дівчинки на рецепції. Клініка сучасно оформлена, все нове чисто і якщо ви не встигли з якихось причин підготувати порожнину рота до огляду, персонал подбає і завжди це можна зробити в клініці.',
    date: '2 роки тому'
  },
  {
    id: 13,
    name: 'Аніна Очеретяна',
    rating: 5,
    text: 'Проходжу лікування в даній стоматології достатньо довго, а саме у лікаря ортодонта Людмили Володимирівни. Професіонал своєї справи 😍 дуже рекомендую всім!',
    date: '9 місяців тому'
  },
  {
    id: 14,
    name: 'Nataliya Mushtatenko',
    rating: 5,
    text: 'Клініка сучасна, спеціалісти самі найкращі. Після відвідування цієї клініки в іншу йти не хочеться. Бо тільки тут професійний підхід до кожного клієнта, проблеми та гаманця)))',
    date: 'Рік тому'
  },
  {
    id: 15,
    name: 'Лідія Пінаєва',
    rating: 5,
    text: 'Коли потрапляєш у вашу клініку, одразу відчуваєш рівень 🔥, у вас все прогресивно і великим кроком у майбутнє. Підхід до пацієнта супер, абсолютна орієнтованість на пацієнта – це дуже спонукає радити вашу клініку всім друзям. Ви молодці!',
    date: 'Рік тому'
  },
  {
    id: 16,
    name: 'ЛА-11 Касян Єлизавета',
    rating: 5,
    text: 'Відмінна клініка і окремо хочу подякувати та порекомендувати лікаря Артема Івановича, досвідчений лікар і професіонал своєї справи. Видалення зубів мудрості пройшло взагалі без болю та дискомфорту. З радістю рекомендую дану клініку)',
    date: 'Рік тому'
  },
  {
    id: 17,
    name: 'Ольга',
    rating: 5,
    text: 'Чудова клініка. Дану клініку вибрала за рекомендацією знайомих і зараз проходжу ортодонтичне лікування, підготовчий етап до установки брекетів теж пройшла в даній клініці, а саме лікування карієсу та видалення вісімок. Все пройшло чудово!',
    date: 'Рік тому'
  },
  {
    id: 18,
    name: 'Ростислав Базванов',
    rating: 5,
    text: 'Задоволений якістю надання послуг. Всі зуби лікувались ретельно і з увагою до моїх побажань. Відчув індивідуальний підхід до моїх проблем, які виявились неординарними. Дякую за професіоналізм!',
    date: 'Рік тому'
  },
  {
    id: 19,
    name: 'Зілінченок Міріам Ігорівна',
    rating: 5,
    text: 'Чудова клініка. Спеціалісти тут завжди уважні, дбайливі та професійні, атмосфера в кабінеті дуже затишна. Щиро рекомендую всім, хто шукає надійного стоматолога!',
    date: 'Рік тому'
  },
  {
    id: 20,
    name: 'Hanna Chorna',
    rating: 5,
    text: 'Привіт! Хочу висловити вдячність Сергію та його професійній команді. Я з ними вже другий рік і однозначно не останній. Більше за все я задоволена результатом реставрації переднього зуба. В той час як мені інші спеціалісти пропонували інші варіанти.',
    date: 'Рік тому'
  },
  {
    id: 21,
    name: 'Larisa Kalik',
    rating: 5,
    text: 'Хочу поділитися відмінним досвідом в цій стоматологічній клініці. Особливо дякую лікарю Артему — він видаляв мені зуби мудрості, і все пройшло просто ідеально. Швидко, без болю і без проблем після. Дуже спокійний і впевнений, одразу видно професіонала.',
    date: '6 місяців тому'
  },
  {
    id: 22,
    name: 'TANYA SHEPEL',
    rating: 5,
    text: 'В цій клініці я вже постійний клієнт. Робила чистку зубів, видаляла зуб мудрості, зараз в процесі процедура імплантації. Будь-яка процедура проходить максимально комфортно, з турботою лікаря до мене і завжди без ускладнень. Рекомендую безсумнівно',
    date: '2 роки тому'
  },
  {
    id: 23,
    name: 'Софья Софьєва',
    rating: 5,
    text: 'Робила відбілювання, все пройшло дуже добре. Все було на вищому рівні. Професійно, акуратно і гарно. 10/10, чистка + відбілювання тривало десь 2 години. Вийшла з кристально чистими зубами, а головне білими. P.S. Дівчинка адмін Аліна - дуже приємна🤗',
    date: '9 місяців тому'
  },
  {
    id: 24,
    name: 'Олена Федьоха',
    rating: 5,
    text: 'Була сьогодні в клініці, вперше, випадково потрапивши, чоловік знайшов в гуглі і так задоволена, що він знайшов цю клініку. Видаляла зуб мудрості, настільки професійно і чутко все робили, що я навіть іноді терялась. Все швидко і безболісно, вдячна 🙏',
    date: '7 місяців тому'
  }
];

export const doctors = [
  'Цвятков Артем Іванович (Головний лікар)',
  'Романова Анна Юріївна (Щелепно-лицевий хірург)',
  'Зубков Максим Ігорович (Лікар-ортопед)',
  'Крук Ілона Сергіївна (Лікар-терапевт)',
  'Гаврилова Юлія Олегівна (Лікар-пародонтолог)',
  'Добровольський Дмитро Валерійович (Лікар-терапевт (ендодонтист))',
  'Цвяткова Людмила Володимирівна (Лікар-ортодонт)'
];

export const timeSlots = [
  '09:00', '10:00', '11:00', '12:00', '13:00', 
  '14:00', '15:00', '16:00', '17:00', '18:00', '19:00'
];